import { Injectable } from '@angular/core';
import { HttpClient, HttpHeaders } from '@angular/common/http';

import { Observable } from 'rxjs/Observable';
import { of } from 'rxjs/observable/of';
import { catchError, map, tap } from 'rxjs/operators';

import { ComponentBaseService } from './component-base.service'
import { ServicesConstants } from '../services-constants'
import { LottoSpedizione } from '../_models/lotto-spedizione';
import { StatoLottoSpedizione } from '../_models/stato-lotto-spedizione';
import { Utils } from '../utils';
import { LottoSpedizioneRef } from '../_models/lotto-spedizione-ref';
import { LottoProduzioneRef } from '../_models/lotto-produzione-ref';
import { ParamsComposizioneLotto } from '../_models/params-composizione-lotto';
import { ParamsSpedizioneLotto } from '../_models/params-spedizione-lotto';
import { delayedRetry } from './delayed-retry';

@Injectable()
export class LottoSpedizioneService extends ComponentBaseService {

  constructor(
    private http: HttpClient
  ) {
    super();
  }

  getServiceName(): string {
    return "LottoSpedizioneService";
  }

  /** GET LottoSpedizione by id. Will 404 if id not found */
  getElencoLottiSpedizione(statoLotto: number[], numeroLottoSpedizione: string, tipoProdotto: string): Observable<LottoSpedizioneRef[]> {
    let url = `${ServicesConstants.URL_LOTTISPEDIZIONE}`;

    let prms = [];
    if (statoLotto != null) prms.push("statoLotto=" + statoLotto);
    if (numeroLottoSpedizione != null) prms.push("numeroLottoSpedizione=" + numeroLottoSpedizione);
    if (tipoProdotto != null) prms.push("tipoProdotto=" + tipoProdotto);

    if (prms.length > 0) {
      url = url + "/?" + prms.join("&");
    }

    return this.http.get<LottoSpedizioneRef[]>(url).pipe(
      delayedRetry(),
      tap(_ => this.log(`fetched Elenco Lotti Spedizione ${prms.join(", ")}`)),
      catchError(this.handleError<LottoSpedizioneRef[]>(`getElencoLottiSpedizione ${prms.join(", ")}`))
    );
  }

  /** GET LottoSpedizione by id. Will 404 if id not found */
  getLottoSpedizione(id: number): Observable<LottoSpedizione> {
    const url = `${ServicesConstants.URL_LOTTISPEDIZIONE}/${id}`;
    return this.http.get<LottoSpedizione>(url).pipe(
      delayedRetry(),
      tap(_ => this.log(`fetched Lotto Spedizione Locale id=${id}`)),
      catchError(this.handleError<LottoSpedizione>(`getLottoSpedizione id=${id}`))
    );
  }

  /** GET LottoSpedizione by id. Will 404 if id not found */
  getElencoStoricoStati(id: number): Observable<StatoLottoSpedizione[]> {
    let url = `${ServicesConstants.URL_LOTTISPEDIZIONE}/${id}/stati`;

    return this.http.get<StatoLottoSpedizione[]>(url).pipe(
      delayedRetry(),
      tap(_ => this.log(`fetched Elenco Storico Stati Spedizione id=${id}`)),
      catchError(this.handleError<StatoLottoSpedizione[]>(`getElencoStoricoStati id=${id}`))
    );
  }

  /** PUT: avanzamento di stato: spedito */
  setLottoSpedizioneSpedito(idLottoSpedizione: number, corriere: string, trackingId: string, recVer: number): Observable<LottoSpedizione> {
    let url = `${ServicesConstants.URL_LOTTISPEDIZIONE}/${idLottoSpedizione}?cmd=setLottoSpedito`;

    let param = new ParamsSpedizioneLotto();
    param.idLottoSpedizione=idLottoSpedizione;
    param.corriere=corriere;
    param.trackingId=trackingId;
    param.recVer=recVer;
    return this.http.put<LottoSpedizione>(url, param, this.httpOptions).pipe(
      tap((lotto: LottoSpedizione) => this.log(`set LottoSpedizione Spedito w/ id=${lotto.idLottoSpedizione}`)),
      catchError(this.handleError<LottoSpedizione>('setLottoSpedizioneSpedito'))
    );
  }

  /** PUT: avanzamento di stato: consegnato */
  setLottoSpedizioneConsegnato(lotto: LottoSpedizione, codStatoConsegna: number): Observable<LottoSpedizione> {
    let url = `${ServicesConstants.URL_LOTTISPEDIZIONE}/${lotto.idLottoSpedizione}?codStatoConsegna=${codStatoConsegna}&cmd=setLottoConsegnato`;

    return this.http.put<LottoSpedizione>(url, lotto, this.httpOptions).pipe(
      tap((lotto: LottoSpedizione) => this.log(`set LottoSpedizione Consegnato w/ id=${lotto.idLottoSpedizione}, codStatoConsegna=${codStatoConsegna}`)),
      catchError(this.handleError<LottoSpedizione>('setLottoSpedizioneConsegnato'))
    );
  }


  /** GET LottoProduzione by id. Will 404 if id not found */
  getElencoLottiProduzioneAssegnabili(id: number): Observable<LottoProduzioneRef[]> {
    let url = `${ServicesConstants.URL_LOTTISPEDIZIONE}/${id}/lottiProdottiAssegnabili`;

    return this.http.get<LottoProduzioneRef[]>(url).pipe(
      delayedRetry(),
      tap(_ => this.log(`fetched Elenco Lotti Produzione Assegnabili`)),
      catchError(this.handleError<LottoProduzioneRef[]>(`getElencoLottiProduzioneAssegnabili`))
    );
  }

  /** GET LottoProduzione by id. Will 404 if id not found */
  getElencoLottiProduzioneAssegnati(id: number): Observable<LottoProduzioneRef[]> {
    let url = `${ServicesConstants.URL_LOTTISPEDIZIONE}/${id}/lottiProdottiAssegnati`;

    return this.http.get<LottoProduzioneRef[]>(url).pipe(
      delayedRetry(),
      tap(_ => this.log(`fetched Elenco Lotti Produzione Assegnati`)),
      catchError(this.handleError<LottoProduzioneRef[]>(`getElencoLottiProduzioneAssegnati`))
    );
  }


  /** PUT: avanzamento di stato: consegnato */
  setLottoSpedizioneComposto(idLottoSpedizione: number, corriere: string, trackingId: string, recVer: number, elencoIdLottiProdotti: number[]): Observable<LottoSpedizione> {
    let url = `${ServicesConstants.URL_LOTTISPEDIZIONE}/${idLottoSpedizione}?cmd=setLottoComposto`;
    
    let param = new ParamsComposizioneLotto();
    param.idLottoSpedizione=idLottoSpedizione;
    param.corriere=corriere;
    param.trackingId=trackingId;
    param.idLottiAssegnati=elencoIdLottiProdotti;
    param.recVer=recVer;

    return this.http.put<LottoSpedizione>(url, param, this.httpOptions).pipe(
      tap((lotto: LottoSpedizione) => this.log(`setLottoSpedizioneComposto w/ id=${lotto.idLottoSpedizione}`)),
      catchError(this.handleError<LottoSpedizione>('setLottoSpedizioneComposto'))
    );
  }  

}


// WEBPACK FOOTER //
// ./src/app/_services/lotto-spedizione.service.ts